import React, { useState, useEffect, useRef } from "react";
import { useGallery } from "store/gallery";
import { Collections, List, Search, Add } from "./";
import * as Icons from "react-feather";
import Edit from "./Edit";
import ListSearch from "components/list/ListSearch";

export default function Gallery(props) {
  const [addFile, setAddFile] = useState(false);
  const [editFile, setEditFile] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [refreshData, setRefreshData] = useState(false);
  const [showCollections, setShowCollections] = useState(false); // State for mobile collections menu
  const listRef = useRef(null); // Ref for the list container

  const {
    submittDeleteFile,
    dispatch,
    getList,
    listSearch,
    getCollections,
    showGallery,
    handleSelectFile,
    toggleGallery,
  } = useGallery();

  useEffect(() => {
    if (showGallery) {
      dispatch(getList());
      dispatch(getCollections());
    }
  }, [dispatch, refreshData, showGallery]);

  useEffect(() => {
    // Close the list and scroll down slightly when an item is selected from Collections (only on mobile)
    if (window.innerWidth < 768 && listRef.current) {
      // Scroll down by 100px after a short delay to ensure the DOM is updated
      setTimeout(() => {
        listRef.current.scrollBy({ top: 200, behavior: "smooth" });
      }, 100); // Adjust the delay if needed
    }
  }, [showCollections]);

  if (!dispatch) {
    console.error(
      "dispatch مقداردهی نشده است. لطفاً store/gallery را بررسی کنید."
    );
    return null;
  }

  if (!showGallery) {
    return null;
  }

  const handleDeleteFile = (item) => {
    dispatch(
      submittDeleteFile(item?.id, () => {
        setSelectedItem(null);
        setRefreshData((prev) => !prev);
      })
    );
  };

  return (
    <div className="fixed inset-0 z-[99999] flex items-center justify-center bg-gray-800 bg-opacity-50 p-4">
      <div className="bg-white rounded-lg shadow-lg w-full max-w-7xl max-h-screen overflow-hidden flex flex-col">
        {/* Header */}
        <div className="flex items-center justify-between bg-gray-100 p-3 sm:p-4 border-b">
          <h2 className="text-lg sm:text-xl md:text-2xl font-bold text-gray-800">گالری</h2>
          <div className="flex items-center gap-2 sm:gap-3">
            <button
              type="button"
              onClick={() => setAddFile(true)}
              className="flex items-center gap-1 sm:gap-2 bg-violet-500 text-white px-3 py-2 rounded-lg hover:bg-violet-600 transition"
            >
              <Icons.Paperclip size={16} />
              <span className="hidden sm:inline">افزودن</span>
            </button>
            {selectedItem && (
              <>
                <button
                  type="button"
                  onClick={() => handleSelectFile(selectedItem)}
                  className="flex items-center gap-1 sm:gap-2 bg-green-500 text-white px-3 py-2 rounded-lg hover:bg-green-600 transition"
                >
                  <Icons.MousePointer size={16} />
                  <span className="hidden sm:inline">انتخاب</span>
                </button>
                <button
                  type="button"
                  onClick={() => setEditFile(true)}
                  className="flex items-center gap-1 sm:gap-2 bg-orange-500 text-white px-3 py-2 rounded-lg hover:bg-orange-600 transition"
                >
                  <Icons.Edit2 size={16} />
                  <span className="hidden sm:inline">ویرایش</span>
                </button>
                <button
                  type="button"
                  onClick={() => handleDeleteFile(selectedItem)}
                  className="flex items-center gap-1 sm:gap-2 bg-red-500 text-white px-3 py-2 rounded-lg hover:bg-red-600 transition"
                >
                  <Icons.Trash2 size={16} />
                  <span className="hidden sm:inline">حذف</span>
                </button>
              </>
            )}
            <button
              type="button"
              onClick={() => dispatch(toggleGallery())}
              className="flex items-center justify-center text-gray-500 hover:text-red-500 transition"
            >
              <Icons.X size={20} />
            </button>
          </div>
        </div>

        {/* Main Content */}
        <div className="flex-1 p-3 sm:p-4 overflow-auto" >
          {addFile ? (
            <Add
              handleBack={() => {
                setAddFile(false);
                setRefreshData((prev) => !prev);
              }}
            />
          ) : editFile ? (
            <Edit
              item={selectedItem}
              handleBack={() => {
                setEditFile(false);
                setRefreshData((prev) => !prev);
              }}
            />
          ) : (
            <div className="flex flex-col md:flex-row  sm:gap-4">
              {/* Mobile Collections Toggle Button */}
              <button
                type="button"
                onClick={() => setShowCollections(!showCollections)}
                className="md:hidden flex items-center justify-center w-full bg-gray-100 p-2 rounded-lg hover:bg-gray-200 transition gap-3"
              >
                <Icons.Menu size={20} />
                <span className="ml-2">دسته‌بندی‌ها</span>
              </button>

              {/* Collections Section */}
              <div
                className={`w-full md:w-3/12 border-r pr-0 md:pr-4 ${
                  showCollections ? "block" : "hidden"
                } md:block`}
              >
                <Collections
                  onSelect={() => {
                    setShowCollections(false); // Close the collections menu
                  }}
                />
              </div>

              {/* List Section */}
              <div className="w-full md:w-9/12" ref={listRef}>
                <ListSearch search={(key) => dispatch(listSearch(key))} />
                <div className="h-3 sm:h-6"></div>
                <List
                  select={(item) => setSelectedItem(item)}
                  selectedItem={selectedItem}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}